import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

const PriceFilter = ({ onFilter, max }) => {
  const [range, setRange] = useState([0, max || 10000]);

  // 🔥 update slider when max changes
  useEffect(() => {
    if (max > 0) {
      setRange([0, max]);
    }
  }, [max]);

  const handleChange = (value) => {
    setRange(value);
  };

  const handleFilter = () => {
    onFilter({
      min: range[0],
      max: range[1],
    });
  };

  return (
    <div className="price_filter product_sale_widget pro-widget">
      <h3 className="pro-title">Filter by Price</h3>

      {/* SLIDER */}
      <div className="slider-range">
        <Slider
          range
          min={0}
          max={max}
          value={range}
          onChange={handleChange}
          trackStyle={[{ backgroundColor: "#006264" }]}
          handleStyle={[{ borderColor: "#006264" }, { borderColor: "#006264" }]}
          railStyle={{ backgroundColor: "#ddd" }}
        />
      </div>

      {/* INPUT + BUTTON */}
      <div className="price_slider_amount">
        <input
          type="text"
          value={`₹${range[0]} - ₹${range[1]}`}
          readOnly
          placeholder="Add Your Price"
        />

        <button type="button" className="btn-fiter" onClick={handleFilter}>
          Filter
        </button>
      </div>
    </div>
  );
};

export default PriceFilter;
